import { type FC, useCallback, useEffect, useState } from "react";

import { type TosKey } from "../../gql-generated/types";
import { TosModalHeader } from "../../lens-creator-payout/components/messages.generated";
import { TosModal } from "../../shared/components/tos/TosModal";
import { useSetTos } from "../../shared/hooks/useSetTos";
import { useTos } from "../../shared/hooks/useTos";
import { type TosMap, creatorTosModalStore } from "../../shared/models/tosModalStore";

interface GlobalTosModalProps {
    tosKey: TosKey;
}

export const GlobalTosModal: FC<GlobalTosModalProps> = ({ tosKey }) => {
    const { loading: tosLoading, tos, acceptedLatestVersion, acceptedOldVersion } = useTos(tosKey);
    const { loading: setTosLoading, setTosLatestAcceptedVersion } = useSetTos(tosKey);
    const [tosModalVisible, setTosModalVisible] = useState(false);

    const triggerTosAcceptance = useCallback(async () => {
        await setTosLatestAcceptedVersion();
        setTosModalVisible(false);
    }, [setTosLatestAcceptedVersion]);

    const closeTosModal = useCallback(() => {
        creatorTosModalStore.setItem({
            hideTos: true,
        });
        setTosModalVisible(false);
    }, []);

    const dataLoading = tosLoading || setTosLoading;

    useEffect(() => {
        const localstore = creatorTosModalStore.getItem<TosMap>();
        const localForceHideTos = localstore?.hideTos ?? false;
        const showTosModal = acceptedOldVersion && !acceptedLatestVersion && !tosLoading && !localForceHideTos;
        if (showTosModal) {
            setTosModalVisible(true);
        }
    }, [acceptedLatestVersion, acceptedOldVersion, tosLoading]);

    return (
        <TosModal
            tosHeading={<TosModalHeader />}
            tosMetadata={tos?.metadata ?? undefined}
            visible={tosModalVisible}
            disabled={dataLoading}
            loading={dataLoading}
            accepted={acceptedLatestVersion}
            onAccept={triggerTosAcceptance}
            onDismiss={closeTosModal}
        />
    );
};
